
import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import './element-ui'

import './assets/css/common.css'

import './request/http'

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)


import Bread from './components/user/Bread.vue'
Vue.component('Bread', Bread)


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
